import { getAutoAnalysisApi } from 'plugin-assets/shared/auto-analysis/helpers'

export const temporalAnalysisApi = getAutoAnalysisApi(`/services/plugin-liverig-vis/auto-analysis`)
export const { fetchResults, saveAsAnnotation } = temporalAnalysisApi

export default temporalAnalysisApi
